import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  Pagination,
  Paper,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Menu,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import styles from "../css/Table.module.css";

export default function Table() {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [openFilters, setOpenFilters] = useState(false);
  const [selectedUsuario, setSelectedUsuario] = useState([]);
  const [selectedDepto, setSelectedDepto] = useState([]);
  const [selectedMuni, setSelectedMuni] = useState([]);
  const [selectedAnio, setSelectedAnio] = useState("");
  const [selectedMes, setSelectedMes] = useState("");


  const [uniqueUsuarios, setUniqueUsuarios] = useState([]);
  const [uniqueDepartamentos, setUniqueDepartamentos] = useState([]);
  const [uniqueMunicipios, setUniqueMunicipios] = useState([]);
  const [aniosDisponibles, setAniosDisponibles] = useState([]);
  const [mesesDisponibles, setMesesDisponibles] = useState([]);


  const [openColumns, setOpenColumns] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const rowsPerPage = 15;

  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  const columns = [
    { field: "usuario", headerName: "Registrado por", align: "center", headerAlign: "center", flex: 0.15 },
    { field: "departamento", headerName: "Departamento", align: "center", headerAlign: "center", flex: 0.12 },
    { field: "municipio", headerName: "Municipio", align: "center", headerAlign: "center", flex: 0.12 },
    { field: "fecha_registro", headerName: "Fecha registro", align: "center", headerAlign: "center", flex: 0.12 },
    { field: "p1", headerName: "1. ¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p2", headerName: "2. ¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p3", headerName: "3. ¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p4", headerName: "4. ¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p5", headerName: "5. ¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA? ", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p6", headerName: "6. ¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p7", headerName: "7. ¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p8", headerName: "8. ¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p9", headerName: "9. ¿En el Plan municipal de intervenciones se tiene incluidas intervenciones y recursos del Gobierno municipal?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p10", headerName: "10. ¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p11", headerName: "11. ¿En su municipio se han priorizado comunidades para intensificar las acciones?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p12", headerName: "12. ¿Cuántas comunidades han sido priorizadas en su municipio?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p13", headerName: "13. ¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p14", headerName: "14. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p15", headerName: "15. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? ", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p16", headerName: "16. ¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? ", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p17", headerName: "17. ¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p18", headerName: "18. ¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p19", headerName: "19. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p20", headerName: "20. ¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p21", headerName: "21. ¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p22", headerName: "22. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p23", headerName: "23. ¿En el municipio se cuenta con el registro de familias que han sido beneficiadas con programas sociales o institucionales?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p24", headerName: "24. ¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p25", headerName: "25. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p26", headerName: "26. ¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p27", headerName: "27. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p28", headerName: "28. ¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?", align: "center", headerAlign: "center", flex:0.12 },
    { field: "p29", headerName: "29. ¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?", align: "center", headerAlign: "center", flex:0.12 },
  ];

  const handleExportCSV = () => {
    const visibleColumns = columns.filter((c) => columnVisibility[c.field]);
    const csvContent = [
      visibleColumns.map((c) => c.headerName).join(","),
      ...filteredRows.map((row) =>
        visibleColumns.map((c) => row[c.field]).join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "datos.csv");
  };

  const handleExportXLSX = () => {
    const visibleColumns = columns.filter((c) => columnVisibility[c.field]);
    const exportData = filteredRows.map((row) => {
      const obj = {};
      visibleColumns.forEach((col) => {
        obj[col.headerName] = row[col.field];
      });
      return obj;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Datos");
    XLSX.writeFile(wb, "datos.xlsx");
  };
  
  const cargarImagen = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve(img);
      img.onerror = reject;
    });

  const handleExportPDF = async () => {
    try {
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const logo = await cargarImagen("/images/sesan.png");
      const logoWidth = 160;
      const logoHeight = 80;

      const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

      doc.setFontSize(14);
      doc.text("ÍNDICE DE PREGUNTAS", 40, 50);

      doc.addImage(logo, "PNG", 600, 10, logoWidth, logoHeight);

  const indiceData = visibleColumns
    .filter((c) => c.field.startsWith("p"))
    .map((c) => [
      `P${c.field.replace("p", "")}`,
      c.headerName,
    ]);

  autoTable(doc, {
    head: [["Código", "Descripción"]],
    body: indiceData,
    startY: 70,
    styles: {
      fontSize: 8,
      cellPadding: 3,
      overflow: "linebreak",
      cellWidth: 'wrap',
      valign: "top",
    },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 650 },
    },
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: [255, 255, 255],
      halign: "center",
      fontStyle: "bold",
    },
  });

    doc.addPage();
    doc.setFontSize(12);
    doc.text("TABLA DE RESPUESTAS", 40, 50);

    const tableColumn = visibleColumns.map((c) =>
      c.field.startsWith("p") ? `P${c.field.replace("p", "")}` : c.headerName
    );

    const tableRows = filteredRows.map((row) =>
      visibleColumns.map((c) => row[c.field])
    );

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 80,
      styles: {
        fontSize: 7,
        cellPadding: 3,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [52, 152, 219],
        textColor: [255, 255, 255],
        halign: "center",
        fontStyle: "bold",
      },
      bodyStyles: {
        valign: "top",
      },
      margin: { left: 20, right: 20 },
      tableWidth: "auto",
      didDrawPage: () => {
        doc.addImage(logo, "PNG", 600, 10, logoWidth, logoHeight);
      },
    });
    doc.save("datos.pdf");
  } catch (err) {
    console.error("Error al generar PDF:", err);
  }
};


useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const username = user?.username;
    fetch(`/preguntas?username=${username}`)
      .then((res) => res.json())
      .then((data) => {
        const mappedRows = data.map((item, index) => {
          const fecha = item.fecha_registro
            ? (() => {
                try {
                  const d = new Date(item.fecha_registro);
                  return isNaN(d.getTime()) ? item.fecha_registro : d.toLocaleDateString("es-ES");

                } catch {
                  return item.fecha_registro;
                }
              })()
            : "-";

          return {
            id: item.preguntaId ?? index + 1,
            usuario: item.nombre_completo || "-",
            departamento: item.departamento || "-",
            municipio: item.municipio || "-",
            fecha_registro: fecha,
            ...Object.fromEntries(
              Array.from({ length: 29 }, (_, i) => [
                `p${i + 1}`,
                item[`pregunta${i + 1}`] ?? "-",
              ])
            ),
          };
        });

        setRows(mappedRows);
        setFilteredRows(mappedRows);

        setUniqueUsuarios([...new Set(mappedRows.map((r) => r.usuario))]);
        setUniqueDepartamentos([...new Set(mappedRows.map((r) => r.departamento))]);
        setUniqueMunicipios([...new Set(mappedRows.map((r) => r.municipio))]);

        const columnasIniciales = [
          "usuario",
          "departamento",
          "municipio",
          "fecha_registro",
          "p1",
          "p2",
          "p3",
        ];
        setColumnVisibility(
          columns.reduce((acc, col) => {
            acc[col.field] = columnasIniciales.includes(col.field);
            return acc;
          }, {})
        );
      })
      .catch((err) => console.error("Error al obtener datos:", err));
  }, []);

  useEffect(() => {
    if (rows.length === 0) return;

    const anios = [...new Set(
      rows.map(r => {
        const partes = r.fecha_registro.split("/");
        return partes.length === 3 ? partes[2] : null;
      })
    )].filter(Boolean);

    setAniosDisponibles(anios.sort((a, b) => b - a));

    if (selectedAnio) {
      const meses = [...new Set(
        rows
          .filter(r => r.fecha_registro.endsWith(selectedAnio))
          .map(r => Number(r.fecha_registro.split("/")[1]))
      )];
      setMesesDisponibles(meses.sort((a,b)=>a-b));
    }

  }, [rows, selectedAnio]);


  useEffect(() => {
    let filtered = rows;

    if (selectedUsuario.length > 0)
      filtered = filtered.filter((r) => selectedUsuario.includes(r.usuario));

    if (selectedDepto.length > 0)
      filtered = filtered.filter((r) => selectedDepto.includes(r.departamento));

    if (selectedMuni.length > 0)
      filtered = filtered.filter((r) => selectedMuni.includes(r.municipio));

    if (selectedAnio) {
      filtered = filtered.filter(r => {
        const partes = r.fecha_registro.split("/");
        return partes[2] === selectedAnio;
      });
    }

    if (selectedMes) {
      filtered = filtered.filter(r => {
        const partes = r.fecha_registro.split("/");
        return Number(partes[1]) === Number(selectedMes);
      });
    }


    if (searchText) {
      const lower = searchText.toLowerCase();
      filtered = filtered.filter((row) =>
        columns.some(
          (col) =>
            columnVisibility[col.field] &&
            String(row[col.field] || "").toLowerCase().includes(lower)
        )
      );
    }

    setFilteredRows(filtered);
  }, [
  rows,
  selectedUsuario,
  selectedDepto,
  selectedMuni,
  selectedAnio,
  selectedMes,
  searchText,
  columnVisibility
]);

  const handleClearFilters = () => {
    setSelectedUsuario([]);
    setSelectedDepto([]);
    setSelectedMuni([]);
    setSelectedAnio("");
    setSelectedMes("");
    setFilteredRows(rows);
  };


  return (
    <Paper elevation={6} className={styles.paper}>
      <Box className={styles.toolbar}>
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          className={styles.buttonFilter}
          onClick={() => setOpenFilters(true)}
        >
          Filtros
        </Button>

        <TextField
          size="small"
          placeholder="Buscar..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon sx={{ color: "#3949ab", mr: 1 }} />,
          }}
          className={styles.searchField}
        />

        <Button
          variant="outlined"
          startIcon={<ViewColumnIcon />}
          className={styles.buttonColumns}
          onClick={() => setOpenColumns(true)}
        >
          Columnas
        </Button>

        <Button
          variant="outlined"
          startIcon={<GetAppIcon />}
          className={styles.buttonColumns}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          Exportar
        </Button>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => { handleExportCSV(); setAnchorEl(null); }}>Exportar a CSV</MenuItem>
          <MenuItem onClick={() => { handleExportXLSX(); setAnchorEl(null); }}>Exportar a Excel</MenuItem>
          <MenuItem onClick={() => { handleExportPDF(); setAnchorEl(null); }}>Exportar a PDF</MenuItem>
        </Menu>
      </Box>

      <Box className={styles.dataGridContainer}>
        <DataGrid
          rows={paginatedRows}
          columns={columns}
          columnVisibilityModel={columnVisibility}
          onColumnVisibilityModelChange={(newModel) => setColumnVisibility(newModel)}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
          hideFooter
          getRowHeight={() => 40}
        />
      </Box>

      <Box className={styles.paginationWrapper}>
        <Pagination
          count={Math.ceil(filteredRows.length / rowsPerPage)}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
          shape="rounded"
        />
      </Box>

      <Drawer anchor="right" open={openFilters} onClose={() => setOpenFilters(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <h3>Filtros</h3>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Usuario</InputLabel>
            <Select
              multiple
              value={selectedUsuario}
              onChange={(e) => setSelectedUsuario(e.target.value)}
              input={<OutlinedInput label="Usuario" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {uniqueUsuarios.map((u, i) => (
                <MenuItem key={i} value={u}>
                  <Checkbox checked={selectedUsuario.indexOf(u) > -1} />
                  {u}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Departamento</InputLabel>
            <Select
              multiple
              value={selectedDepto}
              onChange={(e) => setSelectedDepto(e.target.value)}
              input={<OutlinedInput label="Departamento" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {uniqueDepartamentos.map((d, i) => (
                <MenuItem key={i} value={d}>
                  <Checkbox checked={selectedDepto.indexOf(d) > -1} />
                  {d}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Municipio</InputLabel>
            <Select
              multiple
              value={selectedMuni}
              onChange={(e) => setSelectedMuni(e.target.value)}
              input={<OutlinedInput label="Municipio" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {uniqueMunicipios.map((m, i) => (
                <MenuItem key={i} value={m}>
                  <Checkbox checked={selectedMuni.indexOf(m) > -1} />
                  {m}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Año</InputLabel>
            <Select
              value={selectedAnio}
              onChange={(e) => {
                setSelectedAnio(e.target.value);
                setSelectedMes("");
              }}
              input={<OutlinedInput label="Año" />}
            >
              {aniosDisponibles.map((a) => (
                <MenuItem key={a} value={a}>
                  {a}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Mes</InputLabel>
            <Select
              value={selectedMes}
              onChange={(e) => setSelectedMes(e.target.value)}
              input={<OutlinedInput label="Mes" />}
              disabled={!selectedAnio}
            >
              {mesesDisponibles.map((m) => (
                <MenuItem key={m} value={m}>
                  {new Date(0, m - 1).toLocaleString("es-ES", { month: "long" })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>



          <Button variant="outlined" color="secondary" fullWidth onClick={handleClearFilters}>
            Limpiar filtros
          </Button>
        </Box>
      </Drawer>

      <Drawer anchor="right" open={openColumns} onClose={() => setOpenColumns(false)}>
        <Box sx={{ width: 280, p: 2 }}>
          <h3>Columnas</h3>

          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Button
              size="small"
              onClick={() =>
                setColumnVisibility(columns.reduce((acc, col) => ({ ...acc, [col.field]: true }), {}))
              }
            >
              Mostrar todo
            </Button>
            <Button
              size="small"
              onClick={() =>
                setColumnVisibility(
                  columns.reduce((acc, col) => ({
                    ...acc,
                    [col.field]: ["usuario", "departamento", "municipio", "fecha_registro", "p1", "p2", "p3"].includes(col.field),
                  }), {})
                )
              }
            >
              Vista básica
            </Button>
          </Box>

          <Box
            sx={{
              maxHeight: "70vh",
              overflowY: "auto",
              pr: 1,
              border: "1px solid #eee",
              borderRadius: 2,
              p: 1,
            }}
          >
            {columns.map((col) => (
              <FormControlLabel
                key={col.field}
                control={
                  <Checkbox
                    checked={columnVisibility[col.field]}
                    onChange={(e) =>
                      setColumnVisibility((prev) => ({
                        ...prev,
                        [col.field]: e.target.checked,
                      }))
                    }
                  />
                }
                label={col.headerName}
                sx={{
                  alignItems: "flex-start",
                  mb: 1.5,
                  "& .MuiFormControlLabel-label": {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.2,
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Drawer>
    </Paper>
  );
}
